import facePageStyles from '../views/facePageStyles';
import assocGroupStyles from './assocGroupStyles';

const docsAssocGroupStyles = (theme) => ({
  ...facePageStyles(theme),
  ...assocGroupStyles(theme),
  iconSize: {
    fontSize: '15px',
  },
  docSummary_leftPanel: {
    marginLeft: '6px',
  },
});

export default docsAssocGroupStyles;
